import Feature17 from './Feature17'
export default Feature17
